import { ApprovalsLimitsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import type { Category } from 'modules/approvals/lib/types'

export const useApprovalFeatures = (category: Category) => {
  const { company } = useCurrentSession()
  const { data } = useQuery(ApprovalsLimitsDocument, {
    variables: { companyId: company.id },
  })

  const approvalLimits = data?.approvals.limitsConnection.nodes || []
  const limitsByCategory = approvalLimits.filter((limit) => limit.category === category)
  const limits = data?.approvals._policies.approvalGroupsEdit.can ? limitsByCategory : []

  const featureAvailable = (feature: string) => {
    const value = limits.find((limit) => limit.feature === feature)?.available

    if (value === undefined) {
      return true
    } else {
      return value
    }
  }

  const canAddGroup = () => featureAvailable('approval_policies')
  const canAddLevel = () => featureAvailable('approval_levels')
  const canAddMultiapprovers = () => featureAvailable('multiapprovers')

  return {
    canAddGroup,
    canAddLevel,
    canAddMultiapprovers,
  }
}
